<script>
	export let class_overwrite = '';
	export let w = '70pt';
</script>

<svg
	class={class_overwrite}
	width={w}
	viewBox="0 0 120 154"
	version="1.1"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		fill="#14141d"
		d=" M 34.62 25.66 C 41.44 18.69 50.02 12.30 59.99 11.33 C 69.16 12.68 76.98 18.41 83.85 24.31 C 95.18 34.72 104.60 47.91 108.26 63.03 C 108.95 66.36 110.02 70.07 108.19 73.24 C 107.05 75.58 104.18 75.72 102.01 76.42 C 102.10 79.97 102.24 83.52 102.34 87.07 C 101.21 85.73 100.11 84.36 98.99 83.02 C 97.79 84.37 96.59 85.71 95.35 87.01 C 95.40 82.01 95.29 77.01 95.00 72.01 C 96.62 71.10 98.24 70.18 99.85 69.25 C 93.82 51.64 82.42 34.95 65.44 26.45 C 62.97 25.43 60.27 23.21 57.52 24.53 C 45.83 29.69 36.08 38.83 29.73 49.88 C 26.06 55.95 23.41 62.55 20.81 69.13 C 22.22 69.89 23.63 70.64 25.06 71.36 C 25.61 76.50 24.75 81.63 24.86 86.78 C 23.69 85.39 22.53 84.00 21.35 82.64 C 20.45 83.70 19.56 84.76 18.69 85.84 C 18.46 86.03 18.00 86.39 17.78 86.57 C 17.93 82.63 18.33 78.72 18.50 74.79 C 15.59 73.78 11.79 72.48 11.42 68.89 C 11.14 63.55 13.89 58.64 15.75 53.78 L 15.67 55.11 C 14.40 59.61 11.68 63.91 12.13 68.73 C 12.50 72.05 16.14 73.06 18.78 74.02 C 23.55 58.05 31.14 41.98 44.53 31.46 C 48.53 28.40 52.84 25.63 57.53 23.75 C 60.04 22.70 62.57 24.29 64.83 25.27 C 80.20 32.57 91.31 46.72 97.84 62.14 C 99.81 66.53 100.75 71.26 101.81 75.92 C 104.42 75.04 107.81 74.17 108.39 70.99 C 109.00 66.48 107.16 62.13 106.29 57.78 C 104.25 59.80 102.10 61.71 99.81 63.44 C 99.96 62.56 100.25 60.81 100.40 59.94 C 99.92 59.62 98.94 59.00 98.45 58.68 C 97.95 57.50 97.44 56.32 96.91 55.15 C 99.16 54.16 101.43 53.21 103.78 52.49 C 102.65 54.55 100.55 55.53 98.41 56.22 C 99.03 56.58 99.65 56.93 100.28 57.29 C 102.24 57.32 104.19 57.37 106.15 57.45 C 99.56 41.00 87.83 26.49 72.79 17.05 C 67.56 14.08 61.36 10.58 55.22 12.89 C 45.02 15.97 37.49 23.81 30.16 31.07 C 30.92 28.81 33.13 27.44 34.62 25.66 Z"
	/>
	<path
		fill="#f89243"
		d=" M 55.22 12.89 C 61.36 10.58 67.56 14.08 72.79 17.05 C 87.83 26.49 99.56 41.00 106.15 57.45 C 104.19 57.37 102.24 57.32 100.28 57.29 C 99.65 56.93 99.03 56.58 98.41 56.22 C 100.55 55.53 102.65 54.55 103.78 52.49 C 101.43 53.21 99.16 54.16 96.91 55.15 C 97.44 56.32 97.95 57.50 98.45 58.68 C 98.94 59.00 99.92 59.62 100.40 59.94 C 100.25 60.81 99.96 62.56 99.81 63.44 C 102.10 61.71 104.25 59.80 106.29 57.78 C 107.16 62.13 109.00 66.48 108.39 70.99 C 107.81 74.17 104.42 75.04 101.81 75.92 C 100.75 71.26 99.81 66.53 97.84 62.14 C 91.31 46.72 80.20 32.57 64.83 25.27 C 62.57 24.29 60.04 22.70 57.53 23.75 C 52.84 25.63 48.53 28.40 44.53 31.46 C 31.14 41.98 23.55 58.05 18.78 74.02 C 16.14 73.06 12.50 72.05 12.13 68.73 C 11.68 63.91 14.40 59.61 15.67 55.11 L 15.82 54.75 C 17.93 50.83 20.31 47.02 21.86 42.83 L 21.86 42.82 C 24.27 40.08 26.25 37.01 28.36 34.04 C 29.46 34.94 30.56 35.86 31.64 36.80 C 29.97 37.00 28.29 37.17 26.61 37.32 C 28.59 39.16 30.51 41.38 33.33 41.81 C 32.36 40.69 31.38 39.59 30.39 38.50 C 32.06 38.61 33.74 38.69 35.42 38.76 C 33.53 36.54 30.87 34.87 29.71 32.11 L 30.16 31.07 C 37.49 23.81 45.02 15.97 55.22 12.89 Z"
	/>
	<path
		fill="#14141d"
		d=" M 54.28 15.36 C 56.89 15.34 56.90 19.36 57.65 21.30 C 57.37 21.56 56.82 22.08 56.54 22.34 C 55.64 20.07 54.69 17.78 54.28 15.36 Z"
	/>
	<path
		fill="#14141d"
		d=" M 57.55 14.65 C 60.28 15.41 65.27 14.13 65.64 18.12 C 66.44 17.94 68.03 17.57 68.82 17.39 C 67.29 19.63 65.14 21.31 63.31 23.27 C 63.79 20.74 64.14 18.17 63.68 15.60 C 60.66 16.42 61.08 19.50 60.60 21.92 C 58.55 21.37 59.79 18.76 59.18 17.26 C 58.77 16.61 57.96 15.31 57.55 14.65 Z"
	/>
	<path
		fill="#14141d"
		d=" M 48.52 18.12 C 50.07 17.37 51.79 15.90 53.43 17.35 C 52.63 17.66 51.05 18.29 50.26 18.61 C 51.79 18.79 54.05 18.40 54.61 20.34 C 55.95 22.86 50.79 25.13 50.19 21.73 C 50.95 21.80 52.48 21.96 53.24 22.03 C 53.15 21.66 52.96 20.91 52.86 20.54 C 50.68 21.15 49.29 20.14 48.52 18.12 Z"
	/>
	<path
		fill="#14141d"
		d=" M 42.86 21.65 C 44.13 20.82 45.37 19.93 46.72 19.21 C 47.67 20.05 48.06 21.27 48.59 22.38 C 49.39 22.86 51.57 25.29 49.12 24.78 C 48.66 24.75 47.74 24.68 47.28 24.64 C 47.05 23.38 46.84 22.12 46.62 20.86 C 42.49 21.99 48.68 24.89 47.10 26.99 C 44.95 26.11 44.28 23.35 42.86 21.65 Z"
	/>
	<path
		fill="#14141d"
		d=" M 73.32 21.25 C 75.33 19.68 78.65 22.86 77.15 24.99 C 76.37 26.80 73.99 28.83 72.27 26.81 C 70.03 25.31 71.54 22.39 73.32 21.25 Z"
	/>
	<path
		fill="#ffae61"
		d=" M 72.82 26.31 C 72.82 24.30 73.89 21.53 76.38 22.97 C 75.55 24.43 74.60 25.93 72.82 26.31 Z"
	/>
	<path
		fill="#14141d"
		d=" M 38.30 24.97 C 39.72 24.09 41.16 23.25 42.62 22.44 C 41.82 23.68 40.99 24.89 40.18 26.11 C 41.43 25.69 42.67 25.26 43.93 24.85 C 43.18 26.04 42.39 27.21 41.63 28.39 C 42.99 27.83 44.35 27.29 45.73 26.77 C 44.97 28.54 43.39 29.63 41.87 30.68 C 40.70 28.77 39.50 26.87 38.30 24.97 Z"
	/>
	<path
		fill="#14141d"
		d=" M 75.51 30.27 C 76.56 27.96 78.16 26.01 79.78 24.09 C 81.01 25.31 82.23 26.54 83.39 27.83 C 82.38 27.52 80.36 26.88 79.34 26.57 C 79.80 27.34 80.72 28.90 81.17 29.67 C 79.23 28.37 77.33 29.17 75.51 30.27 Z"
	/>
	<path
		fill="#14141d"
		d=" M 36.04 27.00 C 36.40 26.81 37.14 26.41 37.50 26.22 C 38.41 28.41 39.65 30.53 39.91 32.93 C 37.59 34.42 35.16 30.75 32.99 29.84 C 34.81 28.00 36.56 30.97 38.27 31.30 C 37.53 29.87 36.78 28.43 36.04 27.00 Z"
	/>
	<path
		fill="#14141d"
		d=" M 59.68 30.59 C 77.78 38.13 92.02 55.17 93.98 74.97 C 95.52 87.78 91.38 101.17 83.09 111.05 C 78.04 117.39 71.10 121.88 63.95 125.52 C 73.47 127.27 82.53 130.90 92.10 132.41 C 97.04 133.13 102.68 133.07 106.38 129.18 C 103.76 124.21 98.05 123.04 92.91 123.20 C 92.98 120.50 93.05 117.81 93.12 115.12 C 98.96 115.26 105.84 116.74 108.70 122.47 C 110.00 128.00 110.92 134.63 107.26 139.48 C 103.76 143.48 97.94 143.47 93.06 143.19 C 81.55 142.24 70.62 137.71 59.07 137.20 C 47.19 137.93 35.96 143.00 24.00 143.20 C 19.77 143.07 15.06 142.03 12.36 138.47 C 10.18 135.43 9.24 131.44 10.12 127.77 C 10.05 125.12 10.15 122.20 12.15 120.19 C 15.57 116.05 21.23 115.38 26.23 114.89 C 26.26 117.77 26.27 120.64 26.28 123.52 C 21.55 123.07 16.25 124.53 13.89 129.01 C 15.21 131.45 18.51 132.16 21.07 132.54 C 33.18 133.21 44.40 127.73 56.09 125.49 C 44.22 119.53 34.15 109.53 29.51 96.95 C 23.64 81.24 25.55 62.39 35.82 48.91 C 41.79 40.62 50.42 34.68 59.68 30.59 Z"
	/>
	<path
		fill="#14141d"
		d=" M 84.73 29.86 C 86.65 30.94 88.19 32.52 89.55 34.23 C 87.56 34.57 85.56 34.82 83.57 35.06 C 84.34 36.11 85.12 37.17 85.88 38.23 C 88.15 37.56 90.76 35.17 92.82 37.45 C 91.46 39.54 89.96 41.55 88.31 43.43 C 88.20 42.66 87.98 41.13 87.87 40.37 C 84.74 39.12 82.67 36.34 80.51 33.89 C 82.42 33.61 84.34 33.40 86.26 33.24 C 85.76 32.11 85.25 30.98 84.73 29.86 Z"
	/>
	<path
		fill="#14141d"
		d=" M 31.73 30.63 C 33.87 32.38 36.29 34.19 36.98 37.02 C 34.63 35.62 31.60 33.76 31.73 30.63 Z"
	/>
	<path
		fill="#14141d"
		d=" M 29.28 31.89 L 29.71 32.11 C 30.87 34.87 33.53 36.54 35.42 38.76 C 33.74 38.69 32.06 38.61 30.39 38.50 C 31.38 39.59 32.36 40.69 33.33 41.81 C 30.51 41.38 28.59 39.16 26.61 37.32 C 28.29 37.17 29.97 37.00 31.64 36.80 C 30.56 35.86 29.46 34.94 28.36 34.04 C 26.25 37.01 24.27 40.08 21.86 42.82 C 23.78 38.85 26.42 35.23 29.28 31.89 Z"
	/>
	<path
		fill="#f89243"
		d=" M 32.06 57.18 C 37.66 45.53 48.10 36.76 59.89 31.77 C 74.57 38.54 87.06 51.06 91.32 66.94 C 95.76 80.97 92.52 96.87 83.70 108.51 C 78.46 115.48 71.24 120.70 63.49 124.55 C 61.85 125.34 59.88 125.95 58.12 125.14 C 47.13 120.16 37.63 111.57 32.30 100.67 C 25.60 87.23 25.43 70.68 32.06 57.18 Z"
	/>
	<path
		fill="#231d20"
		d=" M 32.08 75.77 C 33.14 58.98 44.49 43.80 59.91 37.34 C 61.06 38.04 62.23 38.73 63.39 39.42 L 63.38 39.59 C 63.09 51.61 63.29 63.63 63.26 75.64 C 71.57 75.61 79.88 75.55 88.19 75.54 C 87.68 75.83 86.68 76.42 86.17 76.72 C 86.89 77.40 87.60 78.09 88.31 78.78 C 87.96 80.47 87.81 82.19 88.01 83.91 C 87.08 99.35 76.28 112.96 62.48 119.32 C 61.82 119.06 60.49 118.55 59.83 118.29 C 59.65 117.67 59.29 116.42 59.11 115.79 C 59.10 114.51 58.31 113.15 56.90 113.11 C 56.47 114.42 56.82 115.86 57.63 116.94 C 58.18 117.28 59.28 117.96 59.83 118.29 C 60.01 118.78 60.38 119.74 60.56 120.22 C 59.15 119.80 57.76 119.36 56.37 118.90 L 56.38 118.54 C 56.58 106.61 56.50 94.67 56.42 82.74 C 48.45 82.68 40.48 82.68 32.52 82.68 C 32.44 81.45 32.35 80.22 32.29 78.99 C 33.81 80.11 35.45 77.50 33.51 76.87 C 33.15 76.60 32.44 76.05 32.08 75.77 Z"
	/>
	<path fill="#f89243" d=" M 88.94 38.26 C 92.29 38.19 87.53 41.32 88.94 38.26 Z" />
	<path
		fill="#14141d"
		d=" M 26.06 39.31 C 27.73 40.35 29.45 41.48 30.52 43.18 C 31.01 44.67 29.44 45.79 28.55 46.74 C 26.19 46.42 24.18 44.64 23.23 42.51 C 25.13 43.34 27.00 44.21 28.87 45.08 C 30.02 42.16 23.86 41.87 26.06 39.31 Z"
	/>
	<path
		fill="#c41f2f"
		d=" M 60.00 42.56 C 57.75 40.56 62.95 38.64 61.93 41.72 C 61.62 41.96 61.02 42.46 60.71 42.70 L 60.00 42.56 Z"
	/>
	<path
		fill="#ef182c"
		d=" M 63.38 39.59 C 76.85 46.65 86.04 60.58 88.19 75.54 C 79.88 75.55 71.57 75.61 63.26 75.64 C 63.29 63.63 63.09 51.61 63.38 39.59 Z"
	/>
	<path
		fill="#14141d"
		d=" M 89.04 44.90 C 90.45 42.60 92.78 41.24 95.03 39.92 C 96.33 41.71 94.96 43.23 93.88 44.71 C 94.90 44.55 96.95 44.22 97.97 44.06 C 98.05 46.85 94.24 48.20 91.90 48.85 C 92.63 48.01 94.10 46.33 94.83 45.48 C 93.42 45.99 92.00 46.47 90.58 46.92 C 91.43 45.57 92.38 44.28 93.34 43.00 C 91.92 43.67 90.49 44.31 89.04 44.90 Z"
	/>
	<path
		fill="#f99243"
		d=" M 56.79 41.00 C 57.65 42.03 58.47 43.08 59.26 44.16 C 58.48 44.71 57.76 45.32 57.09 46.00 C 56.91 44.34 56.80 42.67 56.79 41.00 Z"
	/>
	<path
		fill="#ffae61"
		d=" M 60.71 42.70 C 61.02 42.46 61.62 41.96 61.93 41.72 L 62.48 41.96 C 63.15 43.10 63.21 44.27 62.67 45.45 C 61.29 46.14 60.12 43.82 60.71 42.70 Z"
	/>
	<path
		fill="#14141d"
		d=" M 15.82 54.75 C 17.06 50.47 19.21 46.41 21.86 42.83 C 20.31 47.02 17.93 50.83 15.82 54.75 Z"
	/>
	<path
		fill="#00a45a"
		d=" M 59.26 44.16 C 61.57 45.37 57.92 48.58 57.09 46.00 C 57.76 45.32 58.48 44.71 59.26 44.16 Z"
	/>
	<path fill="#e61630" d=" M 60.69 48.95 C 58.05 46.81 63.65 46.25 61.45 48.80 L 60.69 48.95 Z" />
	<path
		fill="#14141d"
		d=" M 93.48 50.24 C 95.40 49.05 97.33 47.87 99.25 46.68 C 99.91 48.06 101.22 49.29 101.24 50.88 C 99.80 52.10 98.21 53.13 96.70 54.25 C 95.61 52.92 94.54 51.58 93.48 50.24 Z"
	/>
	<path
		fill="#14141d"
		d=" M 18.72 52.03 C 19.71 50.50 20.77 49.00 22.04 47.68 C 21.69 49.16 21.26 50.62 20.88 52.10 C 21.49 51.61 22.71 50.64 23.32 50.15 C 23.26 50.94 23.14 52.52 23.07 53.31 C 24.29 52.28 25.49 51.24 26.74 50.26 C 26.07 52.00 25.24 53.68 24.33 55.32 C 22.47 54.20 20.59 53.12 18.72 52.03 Z"
	/>
	<path
		fill="#e98c44"
		d=" M 57.16 48.46 C 58.48 47.99 59.49 50.10 58.86 51.14 C 58.59 51.36 58.05 51.82 57.78 52.04 C 56.56 51.50 56.47 49.46 57.16 48.46 Z"
	/>
	<path
		fill="#ffae61"
		d=" M 60.69 48.95 L 61.45 48.80 C 61.75 49.14 62.36 49.82 62.66 50.17 L 62.36 51.01 C 60.76 51.31 60.20 50.62 60.69 48.95 Z"
	/>
	<path
		fill="#f89243"
		d=" M 98.46 49.15 C 101.81 49.09 97.70 52.97 96.11 51.71 C 95.45 50.32 97.44 49.48 98.46 49.15 Z"
	/>
	<path fill="#080f1c" d=" M 23.32 50.15 C 23.68 50.35 23.68 50.35 23.32 50.15 Z" />
	<path
		fill="#159b5a"
		d=" M 57.78 52.04 C 58.05 51.82 58.59 51.36 58.86 51.14 L 59.45 51.78 L 59.18 52.63 L 58.29 52.74 L 57.78 52.04 Z"
	/>
	<path
		fill="#cc1c2e"
		d=" M 60.12 55.30 C 58.54 53.86 61.91 51.93 62.30 54.06 C 61.75 54.37 60.67 54.99 60.12 55.30 Z"
	/>
	<path
		fill="#14141d"
		d=" M 17.79 53.60 C 19.62 54.91 23.31 55.01 23.79 57.47 C 22.47 57.57 21.15 57.56 19.84 57.66 C 20.95 58.74 21.81 59.99 22.41 61.40 C 20.07 60.38 16.84 59.93 15.83 57.20 C 17.02 57.41 18.20 57.64 19.38 57.89 C 18.73 56.51 18.26 55.05 17.79 53.60 Z"
	/>
	<path
		fill="#ffae61"
		d=" M 56.64 54.48 C 58.24 53.64 59.92 57.30 57.92 57.83 C 56.50 57.60 56.22 55.61 56.64 54.48 Z"
	/>
	<path
		fill="#ffae61"
		d=" M 62.30 54.06 C 62.57 56.28 62.74 58.52 62.96 60.75 L 61.91 60.01 C 61.45 60.02 60.53 60.04 60.08 60.05 L 60.56 59.63 C 61.22 59.10 61.88 58.57 62.54 58.05 C 61.27 57.59 60.47 56.67 60.12 55.30 C 60.67 54.99 61.75 54.37 62.30 54.06 Z"
	/>
	<path
		fill="#00a45a"
		d=" M 57.31 58.99 C 57.74 57.33 60.46 58.14 60.56 59.63 L 60.08 60.05 C 58.76 60.50 57.84 60.15 57.31 58.99 Z"
	/>
	<path
		fill="#ffae61"
		d=" M 75.49 58.51 C 76.12 58.46 77.37 58.36 78.00 58.31 C 77.17 60.57 76.27 62.80 75.28 65.00 C 76.54 67.28 77.81 69.56 79.02 71.87 C 78.26 71.81 76.74 71.70 75.98 71.64 C 75.89 70.13 75.18 68.73 74.01 67.77 C 73.88 68.01 73.62 68.50 73.49 68.74 C 72.61 70.63 71.82 72.94 69.16 71.90 C 70.52 69.70 71.59 67.34 72.64 64.98 C 71.36 62.67 70.07 60.35 68.70 58.09 C 70.83 58.20 72.48 59.15 73.09 61.20 C 73.31 61.62 73.75 62.46 73.97 62.88 C 74.65 61.79 75.36 60.62 75.40 59.30 L 75.49 58.51 Z"
	/>
	<path
		fill="#915f37"
		d=" M 102.11 58.11 C 103.42 58.76 103.40 59.42 102.07 60.11 C 100.75 59.48 100.77 58.81 102.11 58.11 Z"
	/>
	<path
		fill="#14141d"
		d=" M 71.49 65.00 C 70.29 62.82 69.15 60.57 68.70 58.09 C 70.07 60.35 71.36 62.67 72.64 64.98 C 71.59 67.34 70.52 69.70 69.16 71.90 L 68.80 72.51 C 69.17 69.84 70.34 67.40 71.49 65.00 Z"
	/>
	<path
		fill="#14141d"
		d=" M 73.09 61.20 C 73.28 59.72 74.05 59.08 75.40 59.30 C 75.36 60.62 74.65 61.79 73.97 62.88 C 73.75 62.46 73.31 61.62 73.09 61.20 Z"
	/>
	<path
		fill="#14141d"
		d=" M 13.73 65.42 C 14.36 63.39 15.12 61.39 16.26 59.58 C 16.49 60.32 16.95 61.80 17.18 62.54 C 18.61 63.04 20.03 63.55 21.44 64.09 C 19.25 66.03 16.11 63.19 13.73 65.42 Z"
	/>
	<path
		fill="#e31832"
		d=" M 60.08 60.05 C 60.53 60.04 61.45 60.02 61.91 60.01 C 61.79 60.40 61.56 61.19 61.45 61.58 L 60.78 61.68 C 60.60 61.27 60.25 60.45 60.08 60.05 Z"
	/>
	<path
		fill="#c7c7c7"
		d=" M 43.14 62.86 C 44.57 62.25 46.10 59.77 47.87 61.11 C 49.92 62.19 51.70 63.70 53.55 65.08 C 51.53 65.60 49.61 66.40 47.75 67.31 C 45.17 67.27 42.97 68.53 40.95 69.99 C 40.89 69.92 40.78 69.77 40.72 69.69 C 40.75 67.32 40.11 65.00 38.36 63.31 L 38.15 63.05 L 39.19 62.30 C 40.65 63.85 42.41 65.36 44.56 65.76 C 43.56 64.34 42.41 63.04 41.32 61.68 L 43.14 62.86 Z"
	/>
	<path
		fill="#e98c44"
		d=" M 57.11 61.51 C 58.33 60.77 59.50 62.82 58.98 63.85 C 58.56 64.09 57.73 64.57 57.31 64.80 C 56.54 63.77 56.47 62.67 57.11 61.51 Z"
	/>
	<path fill="#d89846" d=" M 60.78 61.68 L 61.45 61.58 C 64.39 63.57 59.58 64.90 60.78 61.68 Z" />
	<path
		fill="#f0f0ed"
		d=" M 37.20 64.21 C 37.49 63.99 38.07 63.54 38.36 63.31 C 40.11 65.00 40.75 67.32 40.72 69.69 C 39.44 67.93 38.18 66.16 37.20 64.21 Z"
	/>
	<path
		fill="#00a45a"
		d=" M 57.31 64.80 C 57.73 64.57 58.56 64.09 58.98 63.85 C 61.46 64.31 58.98 68.30 57.42 66.26 C 57.40 65.89 57.34 65.17 57.31 64.80 Z"
	/>
	<path
		fill="#c0a683"
		d=" M 38.94 73.73 C 38.14 70.68 34.18 67.03 37.20 64.21 C 38.18 66.16 39.44 67.93 40.72 69.69 C 40.78 69.77 40.89 69.92 40.95 69.99 C 42.97 68.53 45.17 67.27 47.75 67.31 C 49.61 66.40 51.53 65.60 53.55 65.08 L 54.20 64.91 C 54.72 65.83 56.42 68.18 53.97 67.73 C 52.12 67.38 50.61 68.21 49.37 69.51 C 48.06 70.89 45.95 69.53 44.45 70.41 C 42.55 71.41 40.77 72.62 38.94 73.73 Z"
	/>
	<path
		fill="#cc1d2f"
		d=" M 60.69 68.36 C 57.56 67.74 61.82 64.10 61.92 67.29 C 61.62 67.56 61.00 68.09 60.69 68.36 Z"
	/>
	<path
		fill="#ffae61"
		d=" M 61.92 67.29 C 63.34 67.59 63.13 69.90 62.54 70.88 C 61.20 71.84 59.86 69.43 60.69 68.36 C 61.00 68.09 61.62 67.56 61.92 67.29 Z"
	/>
	<path
		fill="#e79446"
		d=" M 57.20 70.82 C 55.07 68.33 59.64 66.88 58.94 70.23 C 58.66 70.44 58.10 70.86 57.82 71.07 L 57.20 70.82 Z"
	/>
	<path
		fill="#14141d"
		d=" M 73.49 68.74 C 73.62 68.50 73.88 68.01 74.01 67.77 C 75.18 68.73 75.89 70.13 75.98 71.64 C 74.50 72.20 73.09 70.09 73.49 68.74 Z"
	/>
	<path
		fill="#018854"
		d=" M 58.94 70.23 C 60.40 70.32 60.07 72.62 58.88 72.93 C 57.65 73.62 56.77 71.82 57.82 71.07 C 58.10 70.86 58.66 70.44 58.94 70.23 Z"
	/>
	<path fill="#e51731" d=" M 60.54 75.27 C 58.37 72.53 63.71 72.60 61.16 75.11 L 60.54 75.27 Z" />
	<path
		fill="#f89243"
		d=" M 19.35 75.43 C 21.00 74.35 22.87 73.68 24.65 72.87 C 24.69 76.79 24.73 80.72 24.42 84.63 C 23.35 83.72 22.28 82.81 21.21 81.90 C 20.51 82.57 19.10 83.89 18.40 84.55 C 18.63 81.53 18.25 78.32 19.35 75.43 Z"
	/>
	<path
		fill="#ee9445"
		d=" M 56.82 73.51 C 57.56 74.11 59.05 75.29 59.79 75.89 C 59.02 76.61 58.28 77.37 57.55 78.14 L 56.76 78.98 C 55.89 78.03 55.03 77.08 54.19 76.11 C 54.89 76.12 56.28 76.15 56.98 76.16 C 56.94 75.50 56.86 74.17 56.82 73.51 Z"
	/>
	<path
		fill="#f99243"
		d=" M 95.43 73.14 C 97.43 74.11 99.44 75.05 101.47 75.97 C 101.61 78.99 101.64 82.02 101.60 85.04 C 101.00 84.35 99.79 82.97 99.19 82.27 C 97.88 83.05 96.81 84.14 95.65 85.10 C 95.66 81.11 95.58 77.13 95.43 73.14 Z"
	/>
	<path
		fill="#00a45a"
		d=" M 59.79 75.89 L 60.54 75.27 L 61.16 75.11 C 61.09 75.37 60.93 75.89 60.86 76.16 C 60.60 76.93 60.08 78.48 59.82 79.26 L 59.69 79.24 L 57.79 79.14 L 57.55 78.14 C 58.28 77.37 59.02 76.61 59.79 75.89 Z"
	/>
	<path
		fill="#fba949"
		d=" M 61.16 75.11 C 62.38 75.02 63.53 76.21 63.77 77.36 C 63.19 78.79 61.15 77.10 60.86 76.16 C 60.93 75.89 61.09 75.37 61.16 75.11 Z"
	/>
	<path
		fill="#f99243"
		d=" M 35.13 76.11 C 36.83 76.16 38.52 76.24 40.22 76.35 L 39.65 76.99 C 39.41 77.27 38.93 77.82 38.69 78.10 C 37.07 79.57 36.18 76.96 35.13 76.11 Z"
	/>
	<path
		fill="#f99243"
		d=" M 41.40 76.22 C 43.08 76.22 44.77 76.24 46.45 76.29 L 46.00 76.87 C 45.74 77.33 45.23 78.26 44.97 78.73 C 43.33 78.70 42.44 77.25 41.40 76.22 Z"
	/>
	<path
		fill="#f99243"
		d=" M 48.34 75.82 C 49.87 76.14 51.41 76.45 52.94 76.78 C 52.06 77.21 51.40 77.88 50.96 78.77 C 50.59 79.10 49.86 79.75 49.49 80.07 C 50.31 80.68 51.95 81.90 52.77 82.52 C 51.74 82.30 49.68 81.87 48.65 81.66 C 48.75 81.01 48.97 79.72 49.08 79.07 C 48.86 77.98 48.61 76.89 48.34 75.82 Z"
	/>
	<path
		fill="#ffae61"
		d=" M 67.51 76.42 C 68.64 75.53 69.78 75.56 70.94 76.51 L 71.10 77.16 C 70.84 77.44 70.32 77.99 70.06 78.26 C 69.71 78.27 69.01 78.27 68.66 78.28 C 68.37 77.81 67.80 76.89 67.51 76.42 Z"
	/>
	<path
		fill="#00a45a"
		d=" M 73.43 76.66 C 74.32 76.48 76.10 76.11 76.99 75.93 C 79.31 76.08 79.18 78.75 77.93 80.11 C 77.64 79.53 77.06 78.37 76.76 77.79 C 76.33 76.67 75.77 76.63 75.09 77.67 C 74.67 77.42 73.85 76.92 73.43 76.66 Z"
	/>
	<path
		fill="#ffae61"
		d=" M 79.64 76.36 C 81.23 76.34 82.82 76.34 84.40 76.36 L 84.01 76.87 C 83.76 77.34 83.27 78.27 83.02 78.73 C 81.52 78.58 80.62 77.35 79.64 76.36 Z"
	/>
	<path
		fill="#309557"
		d=" M 32.07 78.11 C 32.43 77.80 33.15 77.18 33.51 76.87 C 35.45 77.50 33.81 80.11 32.29 78.99 L 32.07 78.11 Z"
	/>
	<path
		fill="#0e9d5b"
		d=" M 38.69 78.10 C 38.93 77.82 39.41 77.27 39.65 76.99 C 42.36 77.10 39.34 80.76 38.69 78.10 Z"
	/>
	<path
		fill="#00ae64"
		d=" M 46.00 76.87 C 48.11 77.07 46.33 80.32 44.97 78.73 C 45.23 78.26 45.74 77.33 46.00 76.87 Z"
	/>
	<path
		fill="#00a45a"
		d=" M 50.96 78.77 C 51.40 77.88 52.06 77.21 52.94 76.78 C 53.08 77.36 53.35 78.51 53.48 79.08 L 52.65 79.46 L 51.41 79.26 L 50.96 78.77 Z"
	/>
	<path fill="#00b867" d=" M 64.88 77.44 C 68.23 77.61 63.27 80.41 64.88 77.44 Z" />
	<path
		fill="#039659"
		d=" M 71.10 77.16 C 74.13 76.22 71.97 80.70 70.12 78.72 L 70.06 78.26 C 70.32 77.99 70.84 77.44 71.10 77.16 Z"
	/>
	<path
		fill="#f99243"
		d=" M 75.09 77.67 C 75.77 76.63 76.33 76.67 76.76 77.79 C 76.35 77.76 75.51 77.70 75.09 77.67 Z"
	/>
	<path
		fill="#00ad63"
		d=" M 84.01 76.87 C 86.13 77.05 84.42 80.31 83.02 78.73 C 83.27 78.27 83.76 77.34 84.01 76.87 Z"
	/>
	<path
		fill="#ef182c"
		d=" M 68.66 78.28 C 69.01 78.27 69.71 78.27 70.06 78.26 L 70.12 78.72 C 69.88 79.04 69.39 79.69 69.15 80.01 C 68.31 80.70 67.36 81.12 66.30 81.26 C 65.55 79.79 67.40 78.51 68.66 78.28 Z"
	/>
	<path
		fill="#ef182c"
		d=" M 48.65 78.68 L 49.08 79.07 C 48.97 79.72 48.75 81.01 48.65 81.66 C 46.46 82.79 46.69 78.62 48.65 78.68 Z"
	/>
	<path
		fill="#ef182c"
		d=" M 52.65 79.46 L 53.48 79.08 C 53.89 79.29 54.71 79.71 55.12 79.91 L 55.21 80.71 C 54.95 80.96 54.44 81.46 54.18 81.71 C 52.97 81.47 52.46 80.72 52.65 79.46 Z"
	/>
	<path
		fill="#ef182c"
		d=" M 59.69 79.24 L 59.82 79.26 C 60.51 79.29 61.89 79.34 62.57 79.37 L 61.96 80.58 C 61.42 81.10 60.87 81.61 60.31 82.11 C 59.98 82.39 59.34 82.96 59.02 83.25 C 59.10 82.92 59.27 82.26 59.35 81.94 C 59.43 81.26 59.60 79.91 59.69 79.24 Z"
	/>
	<path
		fill="#c9202e"
		d=" M 72.40 81.24 C 71.21 79.42 74.90 78.19 74.86 80.44 C 74.15 81.05 73.33 81.31 72.40 81.24 Z"
	/>
	<path
		fill="#ef182c"
		d=" M 80.12 81.84 C 76.93 81.61 80.08 77.04 81.35 80.06 C 81.04 80.51 80.43 81.40 80.12 81.84 Z"
	/>
	<path
		fill="#e9112b"
		d=" M 85.45 81.14 C 84.95 79.61 85.48 79.05 87.04 79.46 C 87.21 80.67 86.68 81.23 85.45 81.14 Z"
	/>
	<path
		fill="#e59043"
		d=" M 35.82 81.07 C 36.24 79.68 38.81 79.81 38.94 81.32 C 38.60 82.76 35.92 82.56 35.82 81.07 Z"
	/>
	<path
		fill="#e18c42"
		d=" M 42.24 81.17 C 42.54 79.17 46.27 80.18 45.49 82.00 C 44.55 82.79 42.47 82.55 42.24 81.17 Z"
	/>
	<path
		fill="#f69244"
		d=" M 55.21 80.71 C 55.59 80.35 56.34 79.62 56.72 79.25 C 57.38 79.92 58.69 81.27 59.35 81.94 C 59.27 82.26 59.10 82.92 59.02 83.25 C 58.74 83.47 58.19 83.91 57.91 84.13 L 57.40 84.51 C 57.17 83.99 56.73 82.95 56.51 82.43 C 55.93 82.25 54.76 81.89 54.18 81.71 C 54.44 81.46 54.95 80.96 55.21 80.71 Z"
	/>
	<path
		fill="#ffae61"
		d=" M 61.96 80.58 L 63.02 79.60 C 63.82 80.49 64.46 81.50 65.22 82.42 C 64.59 82.34 63.34 82.19 62.71 82.11 C 62.66 82.81 62.55 84.22 62.50 84.93 C 61.95 84.22 60.85 82.81 60.31 82.11 C 60.87 81.61 61.42 81.10 61.96 80.58 Z"
	/>
	<path
		fill="#ffae61"
		d=" M 69.15 80.01 C 69.76 80.70 72.22 81.14 70.71 82.21 C 69.70 82.31 68.69 82.37 67.68 82.41 C 67.34 82.12 66.65 81.55 66.30 81.26 C 67.36 81.12 68.31 80.70 69.15 80.01 Z"
	/>
	<path
		fill="#ffae61"
		d=" M 74.86 80.44 L 75.91 79.70 C 76.62 80.61 77.34 81.53 78.04 82.45 C 76.09 82.41 74.11 82.27 72.40 81.24 C 73.33 81.31 74.15 81.05 74.86 80.44 Z"
	/>
	<path
		fill="#ffae61"
		d=" M 81.35 80.06 C 82.85 79.85 83.42 81.39 84.27 82.30 C 82.77 82.31 81.27 82.32 79.76 82.32 L 80.12 81.84 C 80.43 81.40 81.04 80.51 81.35 80.06 Z"
	/>
	<path
		fill="#00a45a"
		d=" M 32.52 82.68 C 40.48 82.68 48.45 82.68 56.42 82.74 C 56.50 94.67 56.58 106.61 56.38 118.54 C 43.15 111.60 33.30 97.75 32.52 82.68 Z"
	/>
	<path
		fill="#00a45a"
		d=" M 57.91 84.13 C 58.19 83.91 58.74 83.47 59.02 83.25 C 59.27 83.81 59.76 84.94 60.00 85.51 L 59.60 86.18 C 58.19 86.30 57.63 85.62 57.91 84.13 Z"
	/>
	<path
		fill="#c8162d"
		d=" M 60.00 85.51 C 61.21 85.23 61.94 85.68 62.19 86.89 C 61.68 87.05 60.66 87.37 60.16 87.53 C 60.02 87.19 59.74 86.51 59.60 86.18 L 60.00 85.51 Z"
	/>
	<path
		fill="#b5b19c"
		d=" M 44.59 90.98 C 45.13 89.02 44.73 86.21 47.06 85.34 C 47.10 85.77 47.19 86.63 47.23 87.06 L 47.90 87.30 C 47.89 86.83 47.87 85.90 47.87 85.43 C 50.75 86.19 50.11 89.77 50.77 91.99 C 50.79 94.31 53.94 95.48 53.38 97.89 C 51.85 100.29 50.08 102.56 48.64 105.04 C 48.66 104.22 48.68 102.59 48.70 101.78 C 49.59 100.54 50.70 99.10 50.10 97.48 C 50.57 97.21 51.53 96.67 52.00 96.40 C 51.56 95.05 50.52 94.04 49.36 93.27 C 49.17 94.55 49.22 95.82 49.51 97.08 C 49.23 97.19 48.67 97.40 48.39 97.50 L 47.24 97.99 L 46.94 97.39 C 46.68 96.09 46.11 95.43 45.25 95.40 C 44.29 97.64 44.64 100.20 45.77 102.30 C 46.01 102.53 46.48 102.97 46.72 103.19 C 46.95 104.64 47.20 106.09 47.31 107.56 C 45.80 104.87 43.46 102.31 43.68 99.01 C 43.83 95.94 42.66 93.09 41.34 90.39 C 42.15 90.54 43.78 90.83 44.59 90.98 Z"
	/>
	<path
		fill="#88756c"
		d=" M 47.06 85.34 L 47.87 85.43 C 47.87 85.90 47.89 86.83 47.90 87.30 L 47.23 87.06 C 47.19 86.63 47.10 85.77 47.06 85.34 Z"
	/>
	<path
		fill="#eb7e3d"
		d=" M 57.12 87.47 C 58.41 86.88 59.49 88.91 58.85 89.95 C 58.60 90.18 58.09 90.66 57.83 90.90 C 56.52 90.54 56.37 88.42 57.12 87.47 Z"
	/>
	<path
		fill="#ffae61"
		d=" M 60.16 87.53 C 60.66 87.37 61.68 87.05 62.19 86.89 C 62.45 88.38 62.64 89.88 62.80 91.38 C 61.40 90.49 60.54 89.13 60.16 87.53 Z"
	/>
	<path
		fill="#ffffff"
		d=" M 67.92 88.94 C 70.71 86.50 76.78 85.85 78.31 89.96 C 79.12 94.32 78.13 98.75 76.79 102.91 C 76.19 105.88 71.59 106.43 69.91 104.12 C 67.81 99.36 67.24 94.08 67.92 88.94 Z"
	/>
	<path
		fill="#ffae61"
		d=" M 71.03 87.96 C 73.45 86.90 75.77 88.32 77.50 89.92 C 75.34 92.12 72.16 91.41 69.41 91.70 C 70.93 92.14 72.46 92.57 73.99 93.00 C 74.95 92.68 75.92 92.36 76.88 92.04 L 76.63 93.38 C 76.23 94.57 75.82 95.75 75.38 96.93 C 73.10 96.55 70.87 95.99 68.63 95.43 C 69.20 92.95 68.28 89.35 71.03 87.96 Z"
	/>
	<path
		fill="#0c9357"
		d=" M 57.83 90.90 C 58.09 90.66 58.60 90.18 58.85 89.95 C 61.57 90.36 58.10 93.67 57.83 90.90 Z"
	/>
	<path
		fill="#231d20"
		d=" M 69.41 91.70 C 72.16 91.41 75.34 92.12 77.50 89.92 C 77.35 90.45 77.03 91.51 76.88 92.04 C 75.92 92.36 74.95 92.68 73.99 93.00 C 72.46 92.57 70.93 92.14 69.41 91.70 Z"
	/>
	<path
		fill="#3d302a"
		d=" M 43.17 91.47 C 44.35 90.99 45.78 92.76 44.76 93.73 C 43.51 94.56 42.43 92.39 43.17 91.47 Z"
	/>
	<path
		fill="#d21d2f"
		d=" M 60.83 94.38 C 57.75 93.95 61.76 90.12 62.12 93.12 C 61.80 93.43 61.15 94.07 60.83 94.38 Z"
	/>
	<path
		fill="#3d302a"
		d=" M 49.36 93.27 C 50.52 94.04 51.56 95.05 52.00 96.40 C 51.53 96.67 50.57 97.21 50.10 97.48 L 49.51 97.08 C 49.22 95.82 49.17 94.55 49.36 93.27 Z"
	/>
	<path
		fill="#ffae61"
		d=" M 62.12 93.12 C 62.77 94.64 62.63 96.35 62.73 97.97 C 62.07 96.89 59.43 95.68 60.83 94.38 C 61.15 94.07 61.80 93.43 62.12 93.12 Z"
	/>
	<path
		fill="#e88740"
		d=" M 57.95 97.09 C 56.52 96.92 56.27 94.29 57.78 94.08 C 59.02 94.65 59.32 95.57 58.67 96.84 L 57.95 97.09 Z"
	/>
	<path
		fill="#231d20"
		d=" M 75.38 96.93 C 75.82 95.75 76.23 94.57 76.63 93.38 C 76.67 94.16 76.74 95.72 76.77 96.49 L 76.57 96.67 C 75.94 97.25 74.67 98.40 74.04 98.97 C 72.56 98.15 71.09 97.31 69.67 96.40 C 69.41 96.16 68.89 95.67 68.63 95.43 C 70.87 95.99 73.10 96.55 75.38 96.93 Z"
	/>
	<path
		fill="#8faa48"
		d=" M 45.25 95.40 C 46.11 95.43 46.68 96.09 46.94 97.39 C 46.21 98.92 45.46 100.56 45.77 102.30 C 44.64 100.20 44.29 97.64 45.25 95.40 Z"
	/>
	<path
		fill="#b5d86e"
		d=" M 45.77 102.30 C 45.46 100.56 46.21 98.92 46.94 97.39 L 47.24 97.99 C 47.26 99.73 47.37 101.54 46.72 103.19 C 46.48 102.97 46.01 102.53 45.77 102.30 Z"
	/>
	<path
		fill="#a6c354"
		d=" M 48.39 97.50 C 48.67 97.40 49.23 97.19 49.51 97.08 L 50.10 97.48 C 50.70 99.10 49.59 100.54 48.70 101.78 C 48.53 100.36 48.31 98.93 48.39 97.50 Z"
	/>
	<path
		fill="#0a9859"
		d=" M 57.95 97.09 L 58.67 96.84 C 59.00 97.23 59.64 98.03 59.97 98.43 L 59.64 99.15 C 58.04 99.34 57.47 98.65 57.95 97.09 Z"
	/>
	<path
		fill="#f99243"
		d=" M 69.67 96.40 C 71.09 97.31 72.56 98.15 74.04 98.97 C 74.67 98.40 75.94 97.25 76.57 96.67 C 76.32 98.48 76.03 100.28 75.75 102.08 L 75.55 101.36 L 75.29 100.39 C 73.60 100.41 71.91 100.46 70.22 100.54 L 69.95 100.55 C 69.84 99.17 69.74 97.78 69.67 96.40 Z"
	/>
	<path
		fill="#231d20"
		d=" M 47.24 97.99 L 48.39 97.50 C 48.31 98.93 48.53 100.36 48.70 101.78 C 48.68 102.59 48.66 104.22 48.64 105.04 C 48.62 106.30 48.59 107.56 48.57 108.82 C 48.28 109.08 47.70 109.61 47.40 109.87 C 47.38 109.29 47.34 108.14 47.31 107.56 C 47.20 106.09 46.95 104.64 46.72 103.19 C 47.37 101.54 47.26 99.73 47.24 97.99 Z"
	/>
	<path
		fill="#c6182e"
		d=" M 59.97 98.43 C 61.16 98.13 61.89 98.59 62.15 99.80 C 61.66 99.98 60.68 100.35 60.19 100.54 C 60.06 100.19 59.78 99.49 59.64 99.15 L 59.97 98.43 Z"
	/>
	<path
		fill="#eb7e3e"
		d=" M 57.12 100.45 C 58.41 99.85 59.49 101.89 58.86 102.93 C 58.60 103.17 58.09 103.64 57.84 103.88 C 56.54 103.51 56.39 101.40 57.12 100.45 Z"
	/>
	<path
		fill="#ffae61"
		d=" M 60.19 100.54 C 60.68 100.35 61.66 99.98 62.15 99.80 C 62.43 101.31 62.62 102.84 62.79 104.38 C 61.43 103.48 60.59 102.10 60.19 100.54 Z"
	/>
	<path
		fill="#a6603d"
		d=" M 70.22 100.54 C 71.91 100.46 73.60 100.41 75.29 100.39 L 75.55 101.36 C 75.42 102.08 75.17 103.54 75.04 104.26 C 72.26 104.84 70.34 103.41 70.22 100.54 Z"
	/>
	<path
		fill="#089859"
		d=" M 57.84 103.88 C 58.09 103.64 58.60 103.17 58.86 102.93 C 61.57 103.39 58.07 106.67 57.84 103.88 Z"
	/>
	<path
		fill="#d51e30"
		d=" M 60.10 107.22 C 58.54 105.77 61.94 103.90 62.32 106.00 C 61.77 106.31 60.66 106.92 60.10 107.22 Z"
	/>
	<path
		fill="#e4793c"
		d=" M 57.24 106.70 C 58.44 106.35 59.11 108.34 58.78 109.28 C 58.54 109.48 58.04 109.87 57.79 110.07 C 56.62 109.54 56.64 107.66 57.24 106.70 Z"
	/>
	<path
		fill="#ffae61"
		d=" M 62.32 106.00 C 62.51 107.65 62.63 109.30 62.73 110.95 C 61.65 109.86 60.67 108.67 60.10 107.22 C 60.66 106.92 61.77 106.31 62.32 106.00 Z"
	/>
	<path
		fill="#00a45a"
		d=" M 57.79 110.07 C 58.04 109.87 58.54 109.48 58.78 109.28 C 59.09 109.83 59.70 110.95 60.01 111.50 L 59.61 112.16 C 58.21 112.24 57.60 111.54 57.79 110.07 Z"
	/>
	<path
		fill="#c51a2f"
		d=" M 60.01 111.50 C 61.19 111.17 61.91 111.60 62.17 112.79 C 61.67 112.97 60.66 113.35 60.15 113.54 C 60.02 113.19 59.75 112.50 59.61 112.16 L 60.01 111.50 Z"
	/>
	<path
		fill="#eb7e3e"
		d=" M 56.90 113.11 C 58.31 113.15 59.10 114.51 59.11 115.79 C 58.74 116.08 58.00 116.66 57.63 116.94 C 56.82 115.86 56.47 114.42 56.90 113.11 Z"
	/>
	<path
		fill="#ffae61"
		d=" M 60.15 113.54 C 60.66 113.35 61.67 112.97 62.17 112.79 C 62.43 114.29 62.65 115.80 62.78 117.33 C 61.45 116.41 60.57 115.09 60.15 113.54 Z"
	/>
	<path
		fill="#f89243"
		d=" M 15.51 118.63 C 18.42 116.70 21.98 116.39 25.32 115.81 C 25.37 117.99 25.39 120.17 25.41 122.36 C 21.01 122.48 16.19 123.58 13.70 127.59 C 13.19 127.12 12.17 126.19 11.66 125.72 C 10.67 122.65 13.10 120.12 15.51 118.63 Z"
	/>
	<path
		fill="#0a9859"
		d=" M 57.63 116.94 C 58.00 116.66 58.74 116.08 59.11 115.79 C 59.29 116.42 59.65 117.67 59.83 118.29 C 59.28 117.96 58.18 117.28 57.63 116.94 Z"
	/>
	<path
		fill="#f89243"
		d=" M 93.74 116.09 C 99.64 115.76 105.80 118.22 108.59 123.68 C 108.09 125.19 107.60 126.71 107.10 128.23 C 104.05 123.82 98.74 122.36 93.64 122.33 C 93.66 120.25 93.69 118.17 93.74 116.09 Z"
	/>
	<path
		fill="#f99243"
		d=" M 23.98 133.50 C 35.07 132.99 45.37 128.37 56.18 126.41 C 71.22 124.90 84.83 134.80 99.86 133.37 C 104.04 133.04 106.67 129.59 109.17 126.66 C 109.53 130.59 109.72 134.97 107.25 138.32 C 104.90 141.43 100.81 142.61 97.05 142.53 C 84.10 142.67 71.94 136.89 59.07 136.40 C 46.55 137.07 34.70 143.03 22.04 142.35 C 16.01 142.15 10.21 137.25 10.31 130.97 C 9.25 129.14 11.75 127.19 12.79 129.12 C 15.51 132.42 19.82 133.71 23.98 133.50 Z"
	/>
	<path
		fill="#14141d"
		d=" M 56.42 129.55 C 57.49 129.28 58.70 129.99 59.01 131.06 C 60.49 133.06 56.76 135.88 55.42 133.83 C 55.30 132.44 54.17 129.63 56.42 129.55 Z"
	/>
	<path
		fill="#986038"
		d=" M 63.10 128.88 C 64.07 129.14 65.03 129.42 66.00 129.70 C 65.91 131.17 66.11 132.59 66.60 133.97 C 66.41 134.13 66.02 134.46 65.83 134.62 L 65.20 135.19 C 64.46 133.10 63.76 130.99 63.10 128.88 Z"
	/>
	<path
		fill="#14141d"
		d=" M 52.79 129.66 C 53.94 131.32 54.05 133.38 54.36 135.32 C 53.73 134.89 52.48 134.05 51.86 133.63 C 51.70 136.18 49.22 135.81 47.36 135.99 C 46.85 136.28 45.85 136.87 45.35 137.16 C 45.56 135.41 45.72 133.64 46.13 131.92 C 47.93 131.65 48.27 134.20 49.75 134.77 C 49.92 133.36 49.92 131.95 49.76 130.53 C 50.42 131.02 51.76 131.99 52.42 132.48 C 52.51 131.78 52.70 130.37 52.79 129.66 Z"
	/>
	<path
		fill="#14141d"
		d=" M 61.98 133.66 C 62.33 132.06 62.70 130.46 63.10 128.88 C 63.76 130.99 64.46 133.10 65.20 135.19 C 64.13 134.68 63.05 134.17 61.98 133.66 Z"
	/>
	<path
		fill="#14141d"
		d=" M 66.83 130.20 C 68.17 130.66 69.55 131.19 70.93 130.49 C 70.11 132.16 69.47 133.90 70.05 135.79 C 69.71 135.41 69.03 134.65 68.68 134.26 C 67.73 134.37 66.78 134.49 65.83 134.62 C 66.02 134.46 66.41 134.13 66.60 133.97 L 67.97 132.98 C 67.59 132.05 67.21 131.12 66.83 130.20 Z"
	/>
	<path
		fill="#f89243"
		d=" M 56.37 131.11 C 57.96 130.63 58.49 131.22 57.95 132.89 C 56.36 133.34 55.83 132.75 56.37 131.11 Z"
	/>
	<path
		fill="#915d37"
		d=" M 38.91 133.25 C 40.06 132.95 41.22 132.65 42.37 132.36 C 42.66 134.40 42.93 136.44 43.08 138.49 L 42.20 137.51 C 41.01 136.16 39.96 134.70 38.91 133.25 Z"
	/>
	<path
		fill="#14141d"
		d=" M 70.20 134.37 C 71.09 133.27 72.01 132.20 72.96 131.16 C 73.65 131.67 75.03 132.69 75.72 133.20 C 74.06 132.82 72.57 133.08 71.68 134.58 C 72.53 134.79 74.25 135.21 75.11 135.43 C 73.42 137.59 71.56 135.66 70.20 134.37 Z"
	/>
	<path
		fill="#14141d"
		d=" M 75.08 136.27 C 75.60 133.97 76.21 131.54 79.12 132.12 C 78.63 133.28 77.95 134.33 77.18 135.32 C 77.52 135.88 78.18 136.98 78.51 137.53 C 77.66 137.22 75.94 136.59 75.08 136.27 Z"
	/>
	<path
		fill="#14141d"
		d=" M 15.07 134.62 C 18.42 133.99 21.54 135.93 24.87 136.08 C 24.87 136.64 24.86 137.77 24.85 138.33 C 25.36 137.97 26.39 137.26 26.90 136.90 L 26.96 137.03 C 26.98 138.11 27.04 140.26 27.07 141.33 C 26.57 140.81 25.58 139.76 25.08 139.24 C 24.56 139.59 23.50 140.28 22.97 140.63 C 23.14 139.60 23.48 137.52 23.65 136.49 L 21.27 136.31 C 21.47 137.70 21.66 139.10 21.85 140.50 C 20.84 140.07 19.83 139.63 18.81 139.20 C 19.42 137.79 19.60 136.32 18.39 135.14 C 18.72 136.56 18.62 139.68 16.36 138.72 C 15.83 138.23 14.76 137.24 14.23 136.75 C 14.91 136.75 16.28 136.74 16.96 136.74 C 16.48 136.21 15.54 135.15 15.07 134.62 Z"
	/>
	<path
		fill="#14141d"
		d=" M 35.25 135.59 C 34.88 133.53 38.65 134.00 38.00 135.36 C 37.50 135.54 36.51 135.91 36.01 136.09 C 36.00 136.53 35.97 137.40 35.96 137.84 C 37.17 137.67 38.38 137.52 39.60 137.39 C 39.43 136.35 39.08 134.28 38.91 133.25 C 39.96 134.70 41.01 136.16 42.20 137.51 C 39.53 137.33 36.99 140.14 34.54 138.11 C 34.76 137.26 34.99 136.42 35.25 135.59 Z"
	/>
	<path
		fill="#3d302a"
		d=" M 79.54 133.19 L 81.50 133.15 C 81.75 134.54 79.77 137.46 82.50 137.29 C 83.31 136.07 84.11 134.85 84.76 133.55 C 85.10 135.40 84.58 137.77 86.60 138.80 C 87.25 137.58 86.64 134.39 89.00 135.09 C 90.63 135.24 92.35 135.70 93.42 137.05 C 96.74 136.04 100.44 136.42 103.33 134.16 C 103.29 135.26 103.26 136.37 103.24 137.48 C 103.64 137.81 104.44 138.48 104.85 138.81 C 103.60 139.27 102.38 139.80 101.13 140.25 C 100.87 139.52 100.34 138.06 100.08 137.34 C 98.43 137.39 97.28 138.08 96.61 139.43 C 97.57 139.38 99.48 139.29 100.44 139.24 C 99.45 141.31 97.43 141.11 95.63 140.26 C 95.28 140.39 94.59 140.67 94.25 140.81 C 93.95 140.36 93.35 139.46 93.05 139.01 C 92.56 139.47 91.58 140.38 91.08 140.84 C 91.15 139.23 91.21 137.63 91.27 136.03 C 90.74 136.54 89.67 137.56 89.13 138.07 C 89.50 138.61 90.24 139.70 90.61 140.24 C 86.82 139.48 82.94 138.90 79.30 137.55 C 79.27 136.09 79.44 134.64 79.54 133.19 Z"
	/>
	<path
		fill="#3d302a"
		d=" M 30.77 135.74 C 32.27 135.69 33.76 135.64 35.25 135.59 C 34.99 136.42 34.76 137.26 34.54 138.11 C 34.43 138.52 34.22 139.33 34.11 139.74 C 34.19 138.70 34.63 136.64 33.24 136.36 L 32.78 136.83 C 32.14 137.47 31.52 138.14 30.91 138.81 C 30.47 138.81 29.59 138.79 29.15 138.79 L 28.24 138.95 C 27.92 138.47 27.28 137.51 26.96 137.03 L 26.90 136.90 C 26.39 137.26 25.36 137.97 24.85 138.33 C 24.86 137.77 24.87 136.64 24.87 136.08 C 26.68 136.32 29.10 135.76 29.63 138.12 C 30.01 137.32 30.39 136.53 30.77 135.74 Z"
	/>
	<path
		fill="#262124"
		d=" M 33.24 136.36 C 34.63 136.64 34.19 138.70 34.11 139.74 C 32.84 139.33 32.40 138.36 32.78 136.83 L 33.24 136.36 Z"
	/>
	<path
		fill="#14141d"
		d=" M 29.15 138.79 C 29.59 138.79 30.47 138.81 30.91 138.81 C 32.72 141.27 27.36 141.19 29.15 138.79 Z"
	/>
</svg>
